'use client';
import { useOptions } from '@/lib/api/common/options.queries';
import OptionFilterList from './OptionFilterList';
import SidebarSection from './SidebarSection';

const TimeTypeComponent = () => {
  const { data: workTypeOptions } = useOptions({ gkey: 'worktime' });

  return (
    <SidebarSection title="Цагийн төрөл">
      <OptionFilterList options={workTypeOptions} paramName="timeType" />
    </SidebarSection>
  );
};

export default TimeTypeComponent;
